module.exports = __webpack_public_path__ + "media/components/app-store/static/s3-858f695ea0188407392b6b92bd29d892.png";